import { seat, seatImageWithMerchantToken, seatWithMerchantToken } from '@lib/api/v2';

/**
 * 좌석 카테고리 등록
 * @param formdata seatCategoryImage, seatCategoryName
 * @returns
 */
export const postSeatCategory = (formdata: FormData) =>
  seatImageWithMerchantToken.post(`/category`, formdata);

/**
 * 좌석 카테고리 목록 조회
 * @returns
 */
export const getSeatCategory = () => seat.get(`/category`);

/**
 * 좌석 카테고리 수정
 * @param formdata seatCategoryImage, seatCategoryName
 * @returns
 */
export const patchSeatCategory = (formdata: FormData) =>
  seatImageWithMerchantToken.patch(`/category`, formdata);

/**
 * 좌석 카테고리 삭제
 * @param seatCategoryId number
 * @returns
 */
export const deleteSeatCategory = (seatCategoryId: number) =>
  seat.delete(`/category/${seatCategoryId}`);

/**
 * 이용권이 점유 가능한 좌석 목록
 * @param ticketItemId
 * @returns
 */
export const getSeatList = (ticketItemId: number) =>
  seatWithMerchantToken.get(`/list/${ticketItemId}`);

/**
 * 퇴실 예정석 조회
 * @returns
 */
export const getRemainTime = () => seatWithMerchantToken.get(`/remainTime`);

/**
 * 백오피스 좌석 이동 (v2)
 * 서버에서 트랜잭션 + SELECT FOR UPDATE + ticket 상태 가드 적용.
 * @param data ticketId, seatId (이동할 대상 좌석 id)
 */
export const patchBackofficeSeatMove = (data: { ticketId: number; seatId: number }) =>
  seatWithMerchantToken.patch(`/move`, data);
